import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import usePlanOverride from "./hooks/usePlanOverride";

const PlanOverride = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  paramsData,
}) => {
  const planOverrideData = usePlanOverride(
    onSelect,
    hideModal,
    params,
    lookupType,
    paramsData
  );

  return (
    <div class="container container-fluid pop-up">
      <ButtonsSection ctaButtons={planOverrideData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {planOverrideData.screen_title} -{" "}
          <span className="heading-cod">{planOverrideData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={planOverrideData.formFields}
        dropdownValues={planOverrideData.dropdownValues}
        paramsData={planOverrideData.paramsData}
        updataParamData={planOverrideData.updateParamData}
      />
      <ButtonsSection ctaButtons={planOverrideData.ctaButtons} />
      <DisplayTable
        data={planOverrideData.data}
        parmKey={planOverrideData.parmKey}
        menuOptions={planOverrideData.menuOptions}
        tableHeaders={planOverrideData.columnDef}
        setRowData={planOverrideData.setRowData}
        selectedPriceSchedules={planOverrideData.selectedRows}
        setSelectedPriceSchedules={planOverrideData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={planOverrideData.first}
          rows={planOverrideData.rows}
          totalRecords={planOverrideData.totalRecords}
          currentPage={planOverrideData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={planOverrideData.onPageChange}
        />
      </div>
      {planOverrideData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={planOverrideData.isConfirmationModalOpen}
          onRequestClose={planOverrideData.closeConfirmationModal}
          onBack={planOverrideData.closeConfirmationModal}
          onSave={planOverrideData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={planOverrideData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default PlanOverride;
